import React, { useState, useEffect } from 'react';
import { 
  FaFolder, FaPen, FaHandshake, FaUtensils, FaDownload, FaGear, 
  FaUser, FaPenFancy, FaPencil, FaListCheck, FaChartSimple, 
  FaCompassDrafting, FaPlus, FaArrowRight, FaCalendarDay, 
  FaXmark, FaLandmark, FaImage, FaUpload, FaDoorOpen, 
  FaBuilding, FaEye, FaUserGraduate, FaChalkboard, 
  FaBullseye, FaBoxOpen, FaTrashCan, FaCopy, FaCircleXmark, FaMinus, 
  FaUsers,
  FaChevronUp,
  FaChevronDown,
  FaAward,
  FaStar
} from "react-icons/fa6";
import { useParams, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from "framer-motion";
import ConfirmationModal from '../../../components/Modals/project/confirmation-modal';
import axios from '../../../config/axios';
import { useAuth } from '../../../contexts/AuthContext';
import SuccessAlert from '../../../components/ui/succes-alert';
import LoadingSpinner from '../../../components/ui/loading-spinner';
import { AlertTriangle, ArrowRight, Award, BarChart3, BookOpen, Calendar, CalendarDays, Camera, CheckCircle, Clock, Download, FileText, Laptop, Monitor, Package, Plus, ShoppingCart, Target, Trash2, TrendingUp, Upload, UserCheck, Users, Wrench } from 'lucide-react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';


const ProjetDetailForm = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [projet, setProjets] = useState([]);
  const [idEtp, setIdEtp] = useState([]);
  const [activeTab, setActiveTab] = useState('vue-ensemble');
  const [idModule, setIdModule] = useState(null);
  const [isExpanded, setIsExpanded] = useState(true);

  const note = parseFloat(projet?.noteGeneral) || 0;
  const avis = projet?.countNotationProjet || 0;

  const fetchProjectDetails = async (id) => {
    setLoading(true);
    try {
      // 1. Récupération du projet
      const response = await axios.get(`https://badge.mg.formafusion.io/api/projetsForm/${id}/detailForm`);

      const data = await response.data;  
      setProjets(data);


      const idEtp = data.projet.idEtp;
      setIdEtp(idEtp);
      
      const idModule = data.projet.idModule;
      setIdModule(idModule);

      console.log(idModule);

      
    } catch (error) {
      console.error("Détails de l'erreur :", error);
      setLoading(false);
      setError("Impossible de charger le projet. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  const filteredMateriels = projet?.materiels?.filter(m => m.idModule === idModule);

  console.log(filteredMateriels);

  const filteredObjectifs = projet?.objectifs?.filter(o => o.idModule === idModule);

  console.log(filteredObjectifs);

  
  const setting = JSON.parse(sessionStorage.getItem("setting"));

  const getStatusColor = (status) => {
    const colors = {
        "En préparation": "bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-500 animate-pulse",
        "En cours": "bg-gradient-to-r from-blue-400 via-blue-500 to-blue-600 animate-pulse",
        "Terminé": "bg-gradient-to-r from-green-400 via-green-500 to-green-600 animate-pulse",
        "Planifié": "bg-gradient-to-r from-purple-300 via-purple-400 to-purple-500 animate-pulse",
        "Cloturé": "bg-gradient-to-r from-red-800 via-red-700 to-red-900 animate-pulse",
    };
    return colors[status] || "bg-gray-500 animate-pulse";
  };

  const getInitials = (firstname, lastname) => {
    return `${firstname?.charAt(0) || ''}${lastname?.charAt(0) || ''}`.toUpperCase();
  };

  const getPresenceColor = (presence) => {
    if (presence >= 90) return 'text-green-600 bg-green-100';
    if (presence >= 75) return 'text-orange-600 bg-orange-100';
    return 'text-red-600 bg-red-100';
  };

  const getNotationColor = (notation) => {
    if (notation >= 16) return 'text-green-600';
    if (notation >= 12) return 'text-orange-600';
    return 'text-red-600';
  };


    const getTypeIcon = (type) => {
    switch(type) {
      case 'hardware':
        return <Laptop className="w-4 h-4" />;
      case 'software':
        return <Monitor className="w-4 h-4" />;
      case 'infrastructure':
        return <Wrench className="w-4 h-4" />;
      default:
        return <Package className="w-4 h-4" />;
    }
  };

  const getPrioriteColor = (priorite) => {
    switch(priorite) {
      case 'essentiel':
        return 'bg-red-100 text-red-700 border-red-200';
      case 'recommande':
        return 'bg-orange-100 text-orange-700 border-orange-200';
      case 'optionnel':
        return 'bg-blue-100 text-blue-700 border-blue-200';
      default:
        return 'bg-gray-100 text-gray-700 border-gray-200';
    }
  };

  const getPrioriteLabel = (priorite) => {
    switch(priorite) {
      case 'essentiel':
        return 'Essentiel';
      case 'recommande':
        return 'Recommandé';
      case 'optionnel':
        return 'Optionnel';
      default:
        return 'Standard';
    }
  };

  const formaterDateComplete = (dateStr) => {
    const jours = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
    const mois = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 
                  'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
    
    const date = new Date(dateStr);
    const jourSemaine = jours[date.getDay()];
    const jour = date.getDate().toString().padStart(2, '0');
    const moisNom = mois[date.getMonth()];
    const annee = date.getFullYear();
    
    return `${jourSemaine} ${jour} ${moisNom} ${annee}`;
  };
  
  useEffect(() => {
    fetchProjectDetails(id);
  }, [id]);

  
  if (loading) {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <LoadingSpinner/>
        </div>
    );
  }

  if (error) {
    return (
      <div className="text-red-600 text-center py-10">
        {error}
        <button 
          onClick={() => window.location.reload()} 
          className="ml-4 px-4 py-2 bg-blue-500 text-white rounded"
        >
          Réessayer
        </button>
      </div>
    );
  }

  if (!projet || !projet.projet) {
    return (
      <div className="text-center py-10">
         <p className="text-red-500">Aucune donnée de projet disponible</p>
      </div>
    );
  }

  return (
    <>
    <div className="w-full min-h-screen mt-15 ">
        <div className="w-full h-full pb-5">
                   {/* En-tête du projet */}
                    <div className="bg-white overflow-hidden">
                            <div className="flex p-6 mb-8">
                                {/* Section principale - 70% */}
                                <div className="w-[70%] pr-6">
                                    <div className="flex gap-4">
                                        {/* Logo entreprise */}
                                        <div className="flex-shrink-0">
                                            <figure className="w-24 h-24">
                                                {projet.projet.etp_logo ? (
                                                    <img
                                                        src={`https://formafusionmg.ams3.cdn.digitaloceanspaces.com/formafusionmg/img/entreprises/${projet.projet.etp_logo}`}
                                                        className="object-cover w-full h-full rounded-xl shadow-md"
                                                        alt="Entreprise"
                                                        onError={(e) => {
                                                            e.target.src = '/path/to/default-image.png';
                                                        }}
                                                    />
                                                ) : (
                                                    <div className="flex items-center justify-center w-full h-full bg-gradient-to-br from-purple-100 to-purple-200 rounded-xl">
                                                        <FaBuilding className="text-3xl text-purple-500" />
                                                    </div>
                                                )}
                                            </figure>
                                        </div>

                                        {/* Informations du projet */}
                                        <div className="flex flex-col justify-start flex-1 space-y-4">
                                            {/* Titre et références */}
                                            <div className="space-y-2">
                                                <h2 className="text-xl font-bold text-gray-900">
                                                    {projet.projet.module_name || 'Module non spécifié'}
                                                </h2>
                                                <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600">
                                                    <span className="flex items-center gap-1">
                                                        <span className="font-medium">Réf :</span>
                                                        <span className="px-2 py-1 bg-gray-100 rounded-md">
                                                            {projet.projet.project_reference || 'Non spécifiée'}
                                                        </span>
                                                    </span>
                                                    <span className="flex items-center gap-1">
                                                        <span className="font-medium">Dossier :</span>
                                                        <span className="px-2 py-1 bg-gray-100 rounded-md">
                                                            {projet?.project_has?.nomDossier || 'Non spécifié'}
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Notation */}
                                            <div className="flex items-center gap-2 mt-3">
                                              <div className="flex items-center gap-1.5 px-2.5 py-1 bg-gradient-to-r from-amber-50 to-yellow-50 rounded-full border border-amber-200/50 shadow-sm">
                                                <span className="font-bold text-sm bg-gradient-to-r from-amber-600 to-yellow-600 bg-clip-text text-transparent">
                                                  {note.toFixed(1).replace(".", ",")}
                                                </span>
                                                <span className="text-amber-400 text-xs">★</span>
                                              </div>

                                              <div className="flex items-center gap-1 text-gray-500 text-sm">
                                                <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
                                                  <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                                  <path
                                                    fillRule="evenodd"
                                                    d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
                                                    clipRule="evenodd"
                                                  />
                                                </svg>
                                                <span className="font-medium">{avis}</span>
                                              </div>
                                            </div>

                                            {/* Dates */}
                                            <div className="flex items-center gap-6 p-4 bg-gray-50 rounded-lg">
                                                <div className="flex items-center gap-2">
                                                    <span className="font-medium text-gray-700">Début :</span>
                                                    <span className="px-3 py-1 bg-white rounded-md shadow-sm text-gray-800 capitalize">
                                                        {projet.projet.dateDebut ?
                                                            new Date(projet.projet.dateDebut).toLocaleDateString("fr-FR", {
                                                                day: "numeric",
                                                                month: "long",
                                                                year: "numeric",
                                                            }) :
                                                            'Non définie'}
                                                    </span>
                                                </div>
                                                <div className="flex items-center gap-2">
                                                    <span className="font-medium text-gray-700">Fin :</span>
                                                    <span className="px-3 py-1 bg-white rounded-md shadow-sm text-gray-800 capitalize">
                                                        {projet.projet.dateFin ?
                                                            new Date(projet.projet.dateFin).toLocaleDateString("fr-FR", {
                                                                day: "numeric",
                                                                month: "long",
                                                                year: "numeric",
                                                            }) :
                                                            "Non définie"}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Tags */}
                                            <div className="flex flex-wrap items-center gap-3">
                                                <span className="px-4 py-2 bg-blue-50 border border-blue-200 text-blue-700 rounded-full text-sm font-medium">
                                                    {projet.projet.project_type || 'Type non spécifié'}
                                                </span>
                                                <span className="px-4 py-2 bg-cyan-50 border border-cyan-200 text-cyan-700 rounded-full text-sm font-medium">
                                                    {projet.projet.modalite || 'Modalité non spécifiée'}
                                                </span>
                                                 <span
                                                   className={`inline-flex px-4 py-2 text-sm font-semibold text-white rounded-full ${getStatusColor(projet.projet.project_status)}`}
                                                   title="Le projet de formation est en cours de préparation, avec des détails tels que le programme, les supports de formation, et la logistique en cours de finalisation."
                                                  >
                                                      {projet.projet.project_status || 'Statut inconnu'}
                                                  </span>
                                            </div>

                                            {/* Description */}
                                            <div className="mt-4">
                                                <p className="text-gray-700 leading-relaxed line-clamp-3">
                                                    {projet.projet.project_description || 'Aucune description disponible'}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>

                    {/* Onglets */}
                  <div role="tablist" className="w-full p-6 tabs tabs-bordered lg:tabs-lg">
                      <div className="flex flex-col gap-4 max-w-screen-xl mx-auto w-full h-[calc(100vh-30px)] p-4">
                        {/* apprenant */}
                        <div className="w-full max-w-8xl mx-auto p-4">
                                <div className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden">
                                  
                                  {/* En-tête avec gradient */}
                                  <div className="bg-gradient-to-r from-gray-50 to-gray-100">
                                    <div className="px-6 py-4 flex items-center justify-between">
                                      <button
                                        type="button"
                                        onClick={() => setIsExpanded(!isExpanded)}
                                        className="flex items-center gap-4 text-gray-600 hover:bg-white/10 rounded-lg p-2 transition-all duration-200 flex-1"
                                      >
                                        <FaUsers className="text-2xl" />
                                        <div className="flex items-center gap-3">
                                          <span className="text-xl font-semibold">Participants</span>
                                          <span className="bg-white/20 px-3 py-1 rounded-full text-sm font-medium">
                                            {projet?.apprs?.length || 0}
                                          </span>
                                        </div>
                                        <div className="ml-auto">
                                          {isExpanded ? (
                                            <FaChevronUp className="w-5 h-5" />
                                          ) : (
                                            <FaChevronDown className="w-5 h-5" />
                                          )}
                                        </div>
                                      </button>
                                      
                                      <div className="flex items-center gap-3 ml-4">
                                        <button className="bg-white/10 hover:bg-white/20 px-4 py-2 rounded-lg text-gray-600 text-sm font-medium transition-all duration-200 flex items-center gap-2">
                                          <FileText className="w-4 h-4" />
                                          Émargement
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  {/* Contenu extensible */}
                                  <div className={`transition-all duration-500 ease-in-out ${isExpanded ? 'max-h-none opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                                    
                                    {/* Titre de la formation */}
                                    <div className="px-6 py-4 bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-100">
                                      <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-3">
                                        <Award className="w-5 h-5 text-indigo-600" />
                                        {projet?.projet?.etp_name}
                                      </h3>
                                    </div>

                                    {/* Tableau des participants */}
                                    <div className="p-6">
                                      {projet?.apprs && projet.apprs.length > 0 ? (
                                        <div className="space-y-1">
                                          
                                          {/* En-tête du tableau */}
                                          <div className="grid grid-cols-12 gap-4 px-4 py-3 bg-gray-50 rounded-lg font-semibold text-gray-700 text-sm">
                                            <div className="col-span-4 flex items-center gap-2">
                                              <Users className="w-4 h-4" />
                                              Participant
                                            </div>
                                            <div className="col-span-2 flex items-center gap-2">
                                              <UserCheck className="w-4 h-4" />
                                              Présence
                                            </div>
                                            <div className="col-span-2 flex items-center gap-2">
                                              <BarChart3 className="w-4 h-4" />
                                              Note
                                            </div>
                                            <div className="col-span-3 flex items-center gap-2">
                                              <FaAward className="w-4 h-4" />
                                              Compétences
                                            </div>
                                            <div className="col-span-1 text-center"></div>
                                          </div>

                                          {/* Liste des participants */}
                                          <div className="space-y-2">
                                            {projet.apprs.map((participant, index) => (
                                              <div
                                                key={index}
                                                className="grid grid-cols-12 gap-4 items-center px-4 py-4 bg-white border border-gray-200 rounded-xl hover:shadow-md hover:border-indigo-200 transition-all duration-200 group"
                                              >
                                                
                                                {/* Participant Info */}
                                                <div className="col-span-4 flex items-center gap-4">
                                                  <div className="relative">
                                                    {participant.emp_photo && participant.emp_photo.trim() !== "" ? (
                                                      <div className="w-12 h-12 rounded-full overflow-hidden border-2 border-gray-200">
                                                        <img
                                                          src={`https://formafusionmg.ams3.cdn.digitaloceanspaces.com/formafusionmg/img/employes/${participant.emp_photo}`}
                                                          alt={`${participant.emp_name} ${participant.emp_firstname}`}
                                                          className="w-full h-full object-cover"
                                                        />
                                                      </div>
                                                    ) : (
                                                      <div className="flex items-center justify-center w-12 h-12 font-bold text-gray-600 border-1 border-gray-200 rounded-full bg-gradient-to-r from-gray-50 to-gray-100 shadow-sm">
                                                        {getInitials(participant.emp_firstname, participant.emp_name)}
                                                      </div>
                                                    )}
                                                    <div className="absolute -bottom-1 -right-1 w-4 h-4 bg-green-500 border-2 border-white rounded-full"></div>
                                                  </div>
                                                  
                                                  <div className="space-y-1">
                                                    <div className="font-semibold text-gray-800 uppercase text-sm tracking-wide">
                                                      {participant.emp_name}
                                                    </div>
                                                    <div className="text-gray-400 font-medium capitalize text-sm">
                                                      {participant.emp_firstname}
                                                    </div>
                                                  </div>
                                                </div>

                                                {/* Présence */}
                                                <div className="col-span-2">
                                                  <div className="flex items-center gap-2">
                                                    <div className="px-2 py-1 rounded-full text-xs font-semibold text-gray-200">
                                                      {participant.presence}%
                                                    </div>
                                                    {participant.presence >= 80 ? (
                                                      <FaCheckCircle className="w-4 h-4 text-gray-500" />
                                                    ) : (
                                                      <FaTimesCircle className="w-4 h-4 text-gray-500" />
                                                    )}
                                                  </div>
                                                </div>

                                                {/* Notation */}
                                                <div className="col-span-2">
                                                  <div className="flex items-center gap-2">
                                                    <span className={`font-bold text-lg ${getNotationColor(participant.notation)}`}>
                                                     
                                                    </span>
                                                    <div className="flex">
                                                      {[...Array(5)].map((_, i) => (
                                                        <FaStar
                                                          key={i}
                                                          className={`w-3 h-3 ${
                                                            i < Math.floor(participant.notation / 4) 
                                                              ? 'text-yellow-400' 
                                                              : 'text-gray-300'
                                                          }`}
                                                        />
                                                      ))}
                                                    </div>
                                                  </div>
                                                </div>

                                                {/* Compétences */}
                                                <div className="col-span-3">
                                                  <div className="flex flex-wrap gap-1">
                                                    {participant.skills?.slice(0, 2).map((skill, skillIndex) => (
                                                      <span
                                                        key={skillIndex}
                                                        className="px-2 py-1 bg-indigo-100 text-indigo-700 text-xs font-medium rounded-full"
                                                      >
                                                        {skill}
                                                      </span>
                                                    ))}
                                                    {participant.skills?.length > 2 && (
                                                      <span className="px-2 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full">
                                                        +{participant.skills.length - 2}
                                                      </span>
                                                    )}
                                                  </div>
                                                </div>

                                                {/* Actions */}
                                                <div className="col-span-1 text-center">
                            
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      ) : (
                                        <div className="text-center py-12">
                                          <div className="w-20 h-20 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center mx-auto mb-6">
                                            <FaUsers className="w-10 h-10 text-gray-400" />
                                          </div>
                                          <h3 className="text-xl font-semibold text-gray-900 mb-3">Aucun participant</h3>
                                          <p className="text-gray-500 mb-6">Cette formation n'a pas encore de participants inscrits</p>
                                        </div>
                                      )}
                                    </div>

                                    {/* Footer avec statistiques */}
                                    <div className="bg-gray-50 px-6 py-4 border-t border-gray-100">
                                      <div className="flex items-center justify-between">
                                        <div className="flex items-center gap-6 text-sm text-gray-600">
                                          
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                        </div>
                        {/* objectif */}
                        <div className="w-full max-w-8xl mx-auto p-4">
                          <div className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden hover:shadow-2xl transition-all duration-300">
                            
                            {/* En-tête avec gradient */}
                            <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-5">
                              <div className="flex items-center gap-4 text-gray-600">
                                <div className="p-2 bg-white/20 rounded-full">
                                  <Target className="w-6 h-6" />
                                </div>
                                <div>
                                  <h3 className="text-2xl font-bold">Objectifs de la Formation</h3>
                                  <p className="text-gray-600 text-sm mt-1">
                                    Compétences et connaissances à acquérir
                                  </p>
                                </div>
                                <div className="ml-auto flex items-center gap-2">
                                  <span className="bg-white/20 px-3 py-1 rounded-full text-sm font-medium">
                                    {filteredObjectifs?.length || 0} objectifs
                                  </span>
                                </div>
                              </div>
                            </div>

                            {/* Contenu */}
                            <div className="p-6">
                              {Array.isArray(filteredObjectifs) && filteredObjectifs.length > 0 ? (
                                <div className="space-y-4">
                                  {filteredObjectifs.map((objectif, index) => (
                                    <div
                                      key={index}
                                      className="group flex items-start gap-4 p-4 bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl border border-gray-200 hover:border-gray-200 hover:shadow-md transition-all duration-300 hover:scale-[1.02]"
                                    >
                                      {/* Numéro/Icône */}
                                      <div className="flex-shrink-0 relative">
                                        <div className="w-10 h-10 bg-gradient-to-r from-gray-50 to-gray-100 rounded-full flex items-center justify-center text-gray-600 font-bold text-sm shadow-lg">
                                          {index + 1}
                                        </div>
                                        {/* Ligne de connexion (sauf pour le dernier élément) */}
                                        {index < filteredObjectifs.length - 1 && (
                                          <div className="absolute top-12 left-1/2 transform -translate-x-1/2 w-0.5 h-6 bg-gradient-to-r from-gray-50 to-gray-100 to-transparent"></div>
                                        )}
                                      </div>

                                      {/* Contenu de l'objectif */}
                                      <div className="flex-1 space-y-2">
                                        <div className="flex items-center gap-3">
                                          <p className="text-gray-800 font-medium leading-relaxed">
                                            {objectif.objectif}
                                          </p>
                                          <ArrowRight className="w-4 h-4 text-emerald-500 opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
                                        </div>
                                        
                                        {/* Indicateur de progression (optionnel) */}
                                        <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                          <div className="flex-1 bg-gray-200 rounded-full h-1.5">
                                            <div 
                                              className="bg-gradient-to-r from-gray-50 to-gray-100 h-1.5 rounded-full transition-all duration-1000"
                                              style={{ width: `${Math.random() * 40 + 60}%` }}
                                            ></div>
                                          </div>
                                          <span className="text-xs text-gray-500 font-medium">En cours</span>
                                        </div>
                                      </div>

                                      {/* Badge de statut */}
                                      <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                        <CheckCircle className="w-5 h-5 text-emerald-500" />
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              ) : (
                                <div className="text-center py-12">
                                  <div className="w-20 h-20 bg-gradient-to-br from-gray-100 to-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
                                    <Target className="w-10 h-10 text-gray-400" />
                                  </div>
                                  <h3 className="text-xl font-semibold text-gray-900 mb-3">Aucun objectif défini</h3>
                                  <p className="text-gray-500 mb-6 max-w-md mx-auto">
                                    Les objectifs de cette formation n'ont pas encore été définis. Contactez l'administrateur pour plus d'informations.
                                  </p>
                                </div>
                              )}
                            </div>

                            {/* Footer avec informations supplémentaires */}
                            <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-4 border-t border-gray-100">
                              <div className="flex items-center justify-between">
                                <div className="flex items-center gap-4 text-sm text-gray-600">
                                  
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* materiel */}
                        <div className="w-full max-w-8xl mx-auto p-4">
                            <div className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden hover:shadow-2xl transition-all duration-300">
                              
                              {/* En-tête avec gradient */}
                              <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-5">
                                <div className="flex items-center gap-4 text-white">
                                  <div className="p-2 bg-white/20 rounded-full">
                                    <Package className="w-6 h-6 text-gray-600" />
                                  </div>
                                  <div>
                                    <h3 className="text-2xl text-gray-600 font-bold">Matériels Nécessaires</h3>
                                    <p className="text-gray-600 text-sm mt-1">
                                      Équipements et ressources requis pour la formation
                                    </p>
                                  </div>
                                  <div className="ml-auto flex items-center gap-2">
                                    <span className="bg-white/20 px-3 py-1 rounded-full text-sm font-medium">
                                      {filteredMateriels?.length || 0} éléments
                                    </span>
                                  </div>
                                </div>
                              </div>

                              {/* Contenu */}
                              <div className="p-6">
                                {/* Introduction */}
                                <div className="mb-6 p-4 bg-gradient-to-r from-gray-50 to-gray-100 rounded-xl border border-violet-200">
                                  <p className="text-gray-700 leading-relaxed">
                                    <span className="font-semibold text-gray-700">Pour cette formation,</span> les apprenants doivent disposer des matériels et ressources suivants pour optimiser leur expérience d'apprentissage :
                                  </p>
                                </div>

                                {Array.isArray(filteredMateriels) && filteredMateriels.length > 0 ? (
                                  <div className="space-y-4">
                                        <div key="" className="space-y-3">
                                          {filteredMateriels.map((materiel, index) => (
                                            <div
                                              key={index}
                                              className="group flex items-center gap-4 p-4 bg-white border border-gray-200 rounded-xl hover:border-violet-200 hover:shadow-md transition-all duration-200 hover:scale-[1.01]"
                                            >
                                              {/* Icône de type */}
                                              <div className="flex-shrink-0">
                                                <div className="w-10 h-10 bg-gradient-to-r from-gray-50 to-gray-100 rounded-full flex items-center justify-center text-white shadow-lg">
                                                  {/* {getTypeIcon(materiel.type)} */}
                                                </div>
                                              </div>

                                              {/* Contenu */}
                                              <div className="flex-1">
                                                <p className="text-gray-800 font-medium leading-relaxed">
                                                  {materiel.prestation_name}
                                                </p>
                                                <div className="flex items-center gap-3 mt-2">
                                                  <span className="w-1 h-1 bg-gray-300 rounded-full"></span>
                                                  <span className="text-xs px-2 py-1 rounded-full">
                                                  
                                                  </span>
                                                </div>
                                              </div>

                                              {/* Indicateur de statut */}
                                              <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                                {materiel.priorite === 'essentiel' ? (
                                                  <AlertTriangle className="w-5 h-5 text-red-500" />
                                                ) : (
                                                  <CheckCircle className="w-5 h-5 text-green-500" />
                                                )}
                                              </div>
                                            </div>
                                          ))}
                                        </div>
                                  </div>
                                ) : (
                                  <div className="text-center py-12">
                                    <div className="w-20 h-20 bg-gradient-to-br from-gray-100 to-violet-100 rounded-full flex items-center justify-center mx-auto mb-6">
                                      <Package className="w-10 h-10 text-gray-400" />
                                    </div>
                                    <h3 className="text-xl font-semibold text-gray-900 mb-3">Aucun matériel spécifié</h3>
                                    <p className="text-gray-500 mb-6 max-w-md mx-auto">
                                      Les exigences matérielles pour cette formation n'ont pas encore été définies.
                                    </p>
                                    <button className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-violet-600 to-purple-600 text-white rounded-xl hover:from-violet-700 hover:to-purple-700 transition-all duration-200 transform hover:scale-105">
                                      <ShoppingCart className="w-4 h-4" />
                                      Définir les matériels
                                    </button>
                                  </div>
                                )}
                              </div>

                              {/* Footer avec informations supplémentaires */}
                              <div className="bg-gradient-to-r from-gray-50 to-violet-50 px-6 py-4 border-t border-gray-100">
                                <div className="flex items-center justify-between">
                                  <div className="flex items-center gap-4 text-sm text-gray-600">
                                  </div>
                                  <span className="text-xs text-gray-500">Liste mise à jour</span>
                                </div>
                              </div>
                            </div>
                        </div>
                        {/* agenda */}
                        <div className="w-full max-w-8xl mx-auto p-4">
                          <div className="bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden hover:shadow-2xl transition-all duration-300" >
                               {/* En-tête avec gradient */}
                              <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-5">
                                <div className="flex items-center gap-4 text-white">
                                  <div className="p-2 bg-white/20 rounded-full">
                                      <CalendarDays className="w-6 h-6 text-gray-600" />
                                  </div>
                                  <div>
                                    <h3 className="text-2xl font-bold text-gray-600">Agenda</h3>
                                    <p className="text-gray-600 text-sm mt-1">
                                      Équipements et ressources requis pour la formation
                                    </p>
                                  </div>
                                  <div className="ml-auto flex items-center gap-2">
                                  </div>
                                </div>
                              </div>
                              <div className="px-6 py-4 bg-gray-50 border-b border-gray-100">
                                  <div className="flex items-center gap-6">
                                  <div className="flex items-center gap-3">
                                      <div className="p-2 bg-blue-100 rounded-lg">
                                      <Calendar className="w-6 h-6 text-blue-600" />
                                      </div>
                                      <div>
                                      <p className="text-2xl font-bold text-gray-600">
                                          {projet?.seances?.length ?? 0}
                                      </p>
                                      <p className="text-sm text-gray-600">Sessions planifiées</p>
                                      </div>
                                  </div>
                                  
                                  <div className="flex items-center gap-3">
                                      <div className="p-2 bg-green-100 rounded-lg">
                                      <Clock className="w-6 h-6 text-green-600" />
                                      </div>
                                      <div>
                                      <p className="text-2xl font-bold text-gray-600">
                                          {projet?.totalSession?.sumHourSession ?? '0h'}
                                      </p>
                                      <p className="text-sm text-gray-600">Durée totale</p>
                                      </div>
                                  </div>
                                  </div>
                              </div>
                              <div className="px-6 py-6">
                                    {projet?.seances?.length > 0 ? (
                                    <div className="space-y-4">
                                        {projet?.seances?.map((seance, index) => (
                                        <div
                                            key={index}
                                            className="bg-white border border-gray-200 rounded-xl p-5 hover:shadow-md transition-all duration-200 hover:border-blue-200 group"
                                        >
                                            <div className="flex items-center justify-between">
                                            {/* Session Info */}
                                            <div className="flex items-center gap-6">
                                                <div className="flex-shrink-0">
                                                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
                                                    <span className="text-blue-600 font-bold">
                                                    {String(index + 1).padStart(2, '0')}
                                                    </span>
                                                </div>
                                                </div>
                                                
                                                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 flex-1">
                                                <div>
                                                    <p className="text-sm text-gray-500 mb-1">Date</p>
                                                    <p className="font-semibold text-gray-800 capitalize">
                                                    {formaterDateComplete(seance.dateSeance)}
                                                    </p>
                                                </div>
                                                
                                                <div>
                                                    <p className="text-sm text-gray-500 mb-1">Horaires</p>
                                                    <div className="flex items-center gap-2">
                                                    <Clock className="w-4 h-4 text-gray-400" />
                                                    <span className="font-medium text-gray-700">
                                                        {seance.heureDebut} - {seance.heureFin}
                                                    </span>
                                                    </div>
                                                </div>
                                                
                                                <div>
                                                    <p className="text-sm text-gray-500 mb-1">Durée</p>
                                                    <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
                                                    {seance.intervalle_raw}
                                                    </span>
                                                </div>
                                                
                                                <div>
                                                    <p className="text-sm text-gray-500 mb-1">Type</p>
                                                     <span
                                                        className={`inline-flex items-center px-5 w-full text-center py-1 rounded-full text-sm font-medium cursor-pointer ${
                                                          seance.session_catch_up ===
                                                            "Rattrapage" ||
                                                          seance.session_catch_up ===
                                                            "1" ||
                                                          seance.session_catch_up === 1
                                                            ? "bg-orange-100 text-orange-800"
                                                            : "bg-blue-100 text-blue-800"
                                                        }`}
                                                      >
                                                        <p>
                                                          {seance.session_catch_up ===
                                                            "0" ||
                                                          seance.session_catch_up === 0 ||
                                                          seance.session_catch_up ===
                                                            "false"
                                                            ? "Normal"
                                                            : "Rattrapage"}
                                                        </p>
                                                      </span>
                                                </div>
                                                </div>
                                            </div>

                                            {/* Actions */}
                                            <div className="flex-shrink-0 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                                              
                                            </div>
                                            </div>
                                        </div>
                                        ))}
                                    </div>
                                    ) : (
                                    <div className="text-center py-12">
                                        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                                        <Calendar className="w-8 h-8 text-gray-400" />
                                        </div>
                                        <h3 className="text-lg font-medium text-gray-900 mb-2">Aucune session planifiée</h3>
                                        
                                    </div>
                                    )}
                              </div>
                          </div>
                        </div>
                        <div className="w-full max-w-6xl mx-auto space-y-6">
                              {/* Section Programme pédagogique */}
                              <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden group hover:shadow-xl transition-all duration-500">
                                {/* Header */}
                                <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-6 relative overflow-hidden">
                                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -skew-x-12 transform translate-x-full group-hover:-translate-x-full transition-transform duration-1000"></div>
                                  <div className="flex items-center gap-4 text-white relative z-10">
                                    <div className="p-3 bg-white/20 backdrop-blur-sm rounded-xl shadow-lg">
                                      <BookOpen className="w-7 h-7 text-gray-600" />
                                    </div>
                                    <div className="flex-1">
                                      <h3 className="text-2xl font-bold mb-1 text-gray-600">Programme pédagogique</h3>
                                      <p className="text-gray-600 text-sm">
                                        Contenu détaillé et structuré de la formation
                                      </p>
                                    </div>
                                    <div className="bg-white/20 backdrop-blur-sm rounded-full px-4 py-2">
                                      <span className="text-sm font-semibold">Détails</span>
                                    </div>
                                  </div>
                                </div>

                                {/* Contenu expandable */}
                                <div className="p-6 bg-white">
                                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                    <div className="bg-white rounded-xl p-4 shadow-sm border border-blue-100">
                                      <div className="flex items-center gap-2 mb-2">
                                        <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                                        <span className="text-sm font-medium text-gray-600">Modules théoriques</span>
                                      </div>
                                      <p className="text-xs text-gray-600">Concepts fondamentaux</p>
                                    </div>
                                    <div className="bg-white rounded-xl p-4 shadow-sm border border-indigo-100">
                                      <div className="flex items-center gap-2 mb-2">
                                        <div className="w-2 h-2 bg-indigo-500 rounded-full"></div>
                                        <span className="text-sm font-medium text-gray-600">Exercices pratiques</span>
                                      </div>
                                      <p className="text-xs text-gray-600">Mise en application</p>
                                    </div>
                                    <div className="bg-white rounded-xl p-4 shadow-sm border border-purple-100">
                                      <div className="flex items-center gap-2 mb-2">
                                        <div className="w-2 h-2 bg-purple-500 rounded-full"></div>
                                        <span className="text-sm font-medium text-gray-600">Évaluations</span>
                                      </div>
                                      <p className="text-xs text-gray-600">Tests de compétences</p>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Section Ressources téléchargeables */}
                              <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden group hover:shadow-xl transition-all duration-500">
                                {/* Header */}
                                <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-6 py-6 relative overflow-hidden">
                                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent -skew-x-12 transform translate-x-full group-hover:-translate-x-full transition-transform duration-1000"></div>
                                  <div className="flex items-center gap-4 text-white relative z-10">
                                    <div className="p-3 bg-white/20 backdrop-blur-sm rounded-xl shadow-lg">
                                      <Download className="w-7 h-7 text-gray-600" />
                                    </div>
                                    <div className="flex-1">
                                      <h3 className="text-2xl font-bold mb-1 text-gray-600">Ressources téléchargeables</h3>
                                      <p className="text-gray-600 text-sm">
                                        Supports de cours, exercices et documents complémentaires
                                      </p>
                                    </div>
                                    <div className="bg-white/20 backdrop-blur-sm rounded-full px-4 py-2">
                                      <span className="text-sm font-semibold">Accès libre</span>
                                    </div>
                                  </div>
                                </div>

                                {/* Contenu avec liste de ressources */}
                                <div className="p-6 bg-white">
                                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    {/* Support de cours */}
                                    <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                                      <div className="flex items-center justify-between mb-3">
                                        <div className="flex items-center gap-3">
                                          <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center">
                                            <BookOpen className="w-5 h-5 text-gray-600" />
                                          </div>
                                          <div>
                                            <h4 className="font-semibold text-gray-800">Support de cours</h4>
                                            <p className="text-xs text-gray-500">PDF - 2.4 MB</p>
                                          </div>
                                        </div>
                                        <button className="bg-gradient-to-r from-gray-50 to-gray-100 text-gray-600 p-2 rounded-lg transition-colors">
                                          <Download className="w-4 h-4" />
                                        </button>
                                      </div>
                                    </div>

                                    {/* Exercices pratiques */}
                                    <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100 hover:shadow-md transition-shadow">
                                      <div className="flex items-center justify-between mb-3">
                                        <div className="flex items-center gap-3">
                                          <div className="w-10 h-10 bg-gray-100 rounded-lg flex items-center justify-center">
                                            <CalendarDays className="w-5 h-5 text-gray-600" />
                                          </div>
                                          <div>
                                            <h4 className="font-semibold text-gray-800">Exercices pratiques</h4>
                                            <p className="text-xs text-gray-500">DOCX - 1.8 MB</p>
                                          </div>
                                        </div>
                                        <button className="bg-gradient-to-r from-gray-50 to-gray-100 text-gray-600 p-2 rounded-lg transition-colors">
                                          <Download className="w-4 h-4" />
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                  
                                  {/* Note informative */}
                                  <div className="mt-4 bg-white/70 backdrop-blur-sm rounded-xl p-4 border border-gray-200">
                                    <div className="flex items-start gap-3">
                                      <div className="w-5 h-5 bg-gray-500 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                                        <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                      </div>
                                      <div>
                                        <p className="text-sm text-gray-700 font-medium mb-1">Accès illimité</p>
                                        <p className="text-xs text-gray-600">Téléchargez et consultez ces ressources à tout moment, même après la formation.</p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                        </div>
                      </div>
                  </div>
        </div>
    </div>
  </>
  );
};

export default ProjetDetailForm;